import { Directive, inject, TemplateRef, ViewContainerRef } from '@angular/core'

import { Account } from '@account/models'

@Directive({ selector: '[sbDep]' })
export class IfDependentDirective {
  private account = inject(Account)
  private templateRef = inject<TemplateRef<any>>(TemplateRef)
  private viewContainerRef = inject(ViewContainerRef)

  constructor() {
    if (this.account.dependent) {
      this.viewContainerRef.createEmbeddedView(this.templateRef)
    } else {
      this.viewContainerRef.clear()
    }
  }
}
